/* Preserve Shopify's native contact response; restore only this tab's preview template. */
(() => {
 const key='isp-pu-contact-preview';
 const current=new URL(location.href);
 let saved;
 try { saved=JSON.parse(sessionStorage.getItem(key)||'null'); } catch (_) {}
 const fresh=saved && typeof saved.at==='number' && Date.now()-saved.at>=0 && Date.now()-saved.at<900000;
 const validPath=saved && /^\/(?:[a-z]{2}(?:-[A-Za-z]{2})?\/)?pages\/polyurethane-resin-flooring$/.test(saved.path);
 const rootReturn=current.pathname==='/' || /^\/[a-z]{2}(?:-[A-Za-z]{2})?\/?$/.test(current.pathname);
 if(fresh && validPath && (saved.path===current.pathname || rootReturn) && current.hash==='#ISPPuContact' && current.searchParams.get('contact_posted')==='true') {
  try {sessionStorage.removeItem(key);} catch (_) {}
  if(current.pathname!==saved.path || (saved.view==='isp-pu' && current.searchParams.get('view')!=='isp-pu')) {
   current.pathname=saved.path;
   if(saved.view==='isp-pu')current.searchParams.set('view','isp-pu');
   else current.searchParams.delete('view');
   if(typeof saved.preview==='string' && /^\d+$/.test(saved.preview)) current.searchParams.set('preview_theme_id',saved.preview);
   location.replace(current.pathname+current.search+current.hash);
   return;
  }
 }
 // No form data is stored. No submission is intercepted, and no success flag is created.
 document.addEventListener('submit',event=>{
  if(event.target.id!=='ISPPuContact')return;
  if(!document.body.classList.contains('isp-pu'))return;
  const preview=current.searchParams.get('preview_theme_id');
  try {sessionStorage.setItem(key,JSON.stringify({path:current.pathname,at:Date.now(),view:current.searchParams.get('view')==='isp-pu'?'isp-pu':null,preview:preview&&/^\d+$/.test(preview)?preview:null}));} catch (_) {}
 });
})();
